import React from 'react';
import { observer } from 'mobx-react';
const CssIntegerNumberInput = observer(({
  value,
  setValue,
  title = '',
  minValue = 0
}) => {
  const updateVal = val => {
    setValue(val);
  };
  return /*#__PURE__*/React.createElement("span", {
    className: "css-number-integer-input-wrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "css-number-integer-input"
  }, /*#__PURE__*/React.createElement("span", {
    className: "css-number-integer-input-with-title"
  }, title), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: value,
    onChange: e => {
      let newValue = e.target.value;
      updateVal(newValue.replace(/[^0-9]/g, ''));
    },
    onBlur: e => {
      let newVal = e.target.value;
      if (e.target.value === '') {
        newVal = '0.0';
      }
      if (parseInt(minValue) < minValue) {
        newVal = '0.0';
      }
      updateVal(parseInt(newVal));
    }
  }))));
});
export default CssIntegerNumberInput;